module.exports = __webpack_public_path__ + "img/excel.2f5fc7a4.png";